import { fontSize, size } from '@styles/theme'
import styled from '@emotion/styled'
import { Button } from '@mui/material'

const FloatingButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  height: ${size(5)};
  min-width: 0;
  padding: 0 ${size(2)};

  border: 0.5px solid rgba(255,255,255, 0.15);
  border-radius: 100px;
  
  background-color: rgba(20,20,20,0.9);
  color: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.25);
  backdrop-filter: blur(3px);
  
  line-height: ${fontSize('md')};
  font-size: ${fontSize('sm')};
  font-weight: 500;
  
  transition-duration: 300ms;

  &:hover {
    background-color: rgba(20,20,20,0.9);
  }

  &:focus {
    background-color: rgba(20,20,20,0.9);
  }
`

export default FloatingButton
